export default {"src":"/_next/static/media/logo-white.ec80350f.svg","height":24,"width":114,"blurWidth":0,"blurHeight":0};